import type { ApiLocation, Location } from '../types';

export const toLocation = (api: ApiLocation): Location => ({
  id: api.id,
  name: api.name,
});
